const Pagination = (props) => {
  const { activeIndex, setActiveIndex, mixes } = props;

  return (
    <>
      <button
        className={`home__prev-next prev`}
        onClick={() => {
          setActiveIndex((activeIndex - 1 + mixes.length) % mixes.length);
        }}
      >
        <span className="ra__button home__arrow">
          &larr;
        </span>
        
      </button>

      <button
        className={`home__prev-next next`}
        onClick={() => {
          setActiveIndex((activeIndex + 1) % mixes.length);
        }}
      >
      <span className="ra__button home__arrow next">
          &rarr;
        </span>
      </button>
    </>
  );
};

export default Pagination;
